"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberFormatPad = void 0;
/**
 * dodaje widoące zera do liczby
 * @param value liczba
 * @param minLength minimalna, wynikowa długośc tekstu, domyslnie 2
 */
function numberFormatPad(value, minLength = 2) {
    let result = '' + value;
    while (result.length < minLength) {
        result = '0' + result;
    }
    return result;
}
exports.numberFormatPad = numberFormatPad;
//# sourceMappingURL=numberFormatPad.js.map